/* eslint-disable
    func-names,
    max-len,
    no-cond-assign,
    no-shadow,
    no-underscore-dangle,
    no-unused-vars,
    no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/**
 * @class {LocalStorageStore} local storage state.
 * watches local storage for changes
 */

const factory = function ($window, Store) {
  let LocalStorageStore;
  return (LocalStorageStore = class LocalStorageStore extends Store {
    $init() {
      // initial load from localStorage
      this.$fetch();

      // when testing using 'triggerHandler', the first argument is the element
      // whilst the second object is the event. In normal use, the first object
      // is the event.
      return angular.element($window).on('storage', (arg1, arg2) => {
        const event = arg2 || arg1;
        if (event.key === this.$cacheId()) {
          return this.$fetch();
        }
      });
    }

    // handles new data from localStorage
    $serialize(payload) {
      return angular.fromJson(payload);
    }

    $get() {
      return this.$serialize(
        $window.localStorage != null ? $window.localStorage.getItem(this.$cacheId()) : undefined,
      );
    }

    $fetch() {
      let res;
      if (!(res = this.$get())) {
        return;
      }
      this.$set(res.data, { updateTime: res.timestamp });
      return res.data;
    }

    $save(data) {
      if (data) {
        this.$set(data);
      }
      const oldData = __guard__(this.$get(), x => x.data) || {};

      return $window.localStorage != null
        ? $window.localStorage.setItem(
            this.$cacheId(),
            angular.toJson({
              data: angular.extend(oldData, this.$data()),
              timestamp: this.$lastUpdated,
            }),
          )
        : undefined;
    }
  });
};

module.exports = factory;

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
